import { render, staticRenderFns } from "./InJourneyAccordion.vue?vue&type=template&id=45061ed6&scoped=true"
import script from "./InJourneyAccordion.vue?vue&type=script&lang=js"
export * from "./InJourneyAccordion.vue?vue&type=script&lang=js"
import style0 from "./InJourneyAccordion.vue?vue&type=style&index=0&id=45061ed6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45061ed6",
  null
  
)

export default component.exports